import axios from "axios";
import { Platform } from "react-native"; // 💡 1. เพิ่มตัวนี้เข้ามาเพื่อเช็กว่าเป็น Web หรือ มือถือ

export default axios.create({
  // 💡 2. ปรับ baseURL ให้ยืดหยุ่น
  // - ถ้ารันบน Web (Browser) จะยิงเข้าท่อ Nginx ที่เราทำไว้ (/proxy-api) เพื่อแก้ปัญหา CORS และ Mixed Content
  // - ถ้ารันบนแอปมือถือ (Android/iOS) จะวิ่งตรงเข้าหาเซิร์ฟเวอร์หลักผ่าน https ทันที
  baseURL: Platform.OS === 'web' 
    ? "/proxy-api" 
    : "https://spl-api.veninecopper.com", 
});